export const NOTICE_FETCHED = 'NOTICE_FETCHED'


// WEBPACK FOOTER //
// ./src/store/notices/actionTypes.js